import { LinearProgress } from "@mui/material";
import React from "react";

interface CountryUsageProgressBarProps {
  /** 0-100 percentage for the bar width */
  percentage: number;
  color: string;
}

export const CountryUsageProgressBar: React.FC<
  CountryUsageProgressBarProps
> = ({ percentage, color }) => (
  <LinearProgress
    sx={{
      height: 4,
      borderRadius: 0,
      backgroundColor: (theme) => theme.colors.secondary[1],
      "& .MuiLinearProgress-bar": {
        backgroundColor: color,
        borderRadius: 0,
      },
    }}
    value={Math.max(percentage, 0)}
    variant="determinate"
  />
);
